<template>
  <el-dialog
    :title="loadType == 'app' ? '手机端产品下载' : '下载到桌面'"
    :visible.sync="dialogVisible"
    :before-close="handleClose"
    :width="'670px'"
    custom-class="dialog-downapp"
    :top="0"
  >
    <template v-if="loadType == 'app'">
      <div class="goods">
        <div>
          <div class="goods-title">
            <span>经营帮</span>
          </div>
          <div class="goods-list">
            <div
              v-for="(item, index) in jygConf"
              :key="index"
              @click="downLoadApp(item)"
              class="goods-item"
              @mouseenter="setItemRrl(item, 'in')"
              @mouseleave="setItemRrl(item, 'out')"
            >
              <div class="goods_item_qrcode">
                <img
                  :width="item.type === 'qrcode' ? 110 : 64"
                  :src="item.downloadCoed"
                  alt=""
                />
              </div>
              <div class="goods_item_name">
                <span>
                  {{ item.name }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="goods-title">
            <span>企管帮</span>
          </div>
          <div class="goods-list">
            <div
              v-for="(item, index) in qgbConf"
              :key="index"
              @click="downLoadApp(item)"
              class="goods-item"
              @mouseenter="setItemRrl(item, 'in')"
              @mouseleave="setItemRrl(item, 'out')"
            >
              <div class="goods_item_qrcode">
                <div
                  v-if="!item.downloadCoed"
                  style="width:110px; height:110px"
                  :ref="'qgbqrCodeUrl' + index"
                ></div>
                <img
                  v-else
                  :ref="'qgbqrCodeUrl' + index"
                  :width="item.type === 'qrcode' ? 110 : 64"
                  :src="item.downloadCoed"
                  :alt="index"
                />
              </div>
              <div class="goods_item_name">
                <span>
                  {{ item.name }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="goods-title">
            <span>企联多</span>
          </div>
          <div class="goods-list">
            <div
              v-for="(item, index) in qldConf"
              :key="index"
              @click="downLoadApp(item)"
              class="goods-item"
              @mouseenter="setItemRrl(item, 'in')"
              @mouseleave="setItemRrl(item, 'out')"
            >
              <div class="goods_item_qrcode">
                <div
                  v-if="!item.downloadCoed"
                  style="width:110px; height:110px"
                  :ref="'qldqrCodeUrl' + index"
                ></div>
                <img
                  v-else
                  :ref="'qldqrCodeUrl' + index"
                  :width="item.type === 'qrcode' ? 110 : 64"
                  :src="item.downloadCoed"
                  :alt="index"
                />
              </div>
              <div class="goods_item_name">
                <span>
                  {{ item.name }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="goods">
        <div class="goods-title">
          <span>更多产品</span>
        </div>
        <div class="goods-list">
          <div
            v-for="(item, index) in jybConf"
            :key="index"
            @click="downLoadApp(item)"
            class="goods-item"
            @mouseenter="setItemRrl(item, 'in')"
            @mouseleave="setItemRrl(item, 'out')"
          >
            <div class="goods_item_qrcode">
              <img
                :ref="'qldqrCodeUrl' + index"
                :width="item.type === 'qrcode' ? 110 : 64"
                :src="item.downloadCoed"
                :alt="index"
              />
            </div>
            <div class="goods_item_name">
              <span>
                {{ item.name }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="goods">
        <div>
          <div class="goods-title">
            <span>经营帮</span>
          </div>
          <div class="goods-list">
            <div
              v-for="(item, index) in jybPcConf"
              :key="index"
              @click="downLoadApp(item)"
              class="goods-item pc-item"
              @mouseenter="setItemRrl(item, 'in')"
              @mouseleave="setItemRrl(item, 'out')"
            >
              <div class="goods_item_qrcode">
                <img
                  :width="item.type === 'qrcode' ? 110 : 64"
                  :src="item.downloadCoed"
                  alt=""
                />
              </div>
              <div class="goods_item_name">
                <span>
                  经营帮
                </span>
                <span>
                  {{ item.name }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="goods-title">
            <span>企管帮</span>
          </div>
          <div class="goods-list">
            <div
              v-for="(item, index) in qgbPcConf"
              :key="index"
              @click="downLoadApp(item)"
              class="goods-item pc-item"
              @mouseenter="setItemRrl(item, 'in')"
              @mouseleave="setItemRrl(item, 'out')"
            >
              <div class="goods_item_qrcode">
                <div
                  v-if="!item.downloadCoed"
                  style="width:110px; height:110px"
                  :ref="'qgbqrCodeUrl' + index"
                ></div>
                <img
                  v-else
                  :ref="'qgbqrCodeUrl' + index"
                  :width="item.type === 'qrcode' ? 110 : 64"
                  :src="item.downloadCoed"
                  :alt="index"
                />
              </div>
              <div class="goods_item_name">
                <span>企管帮</span>
                <span>
                  {{ item.name }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="goods-title">
            <span>企联多</span>
          </div>
          <div class="goods-list">
            <div
              v-for="(item, index) in qldPcConf"
              :key="index"
              @click="downLoadApp(item)"
              class="goods-item pc-item"
              @mouseenter="setItemRrl(item, 'in')"
              @mouseleave="setItemRrl(item, 'out')"
            >
              <div class="goods_item_qrcode">
                <div
                  v-if="!item.downloadCoed"
                  style="width:110px; height:110px"
                  :ref="'qldqrCodeUrl' + index"
                ></div>
                <img
                  v-else
                  :ref="'qldqrCodeUrl' + index"
                  :width="item.type === 'qrcode' ? 110 : 64"
                  :src="item.downloadCoed"
                  :alt="index"
                />
              </div>
              <div class="goods_item_name">
                <span>企联多</span>

                <span>
                  {{ item.name }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="goods">
        <div>
          <div class="goods-title">
            <span>更多产品</span>
          </div>
          <div class="goods-list">
            <div
              v-for="(item, index) in morePcConf"
              :key="index"
              @click="downLoadApp(item)"
              class="goods-item pc-item"
              @mouseenter="setItemRrl(item, 'in')"
              @mouseleave="setItemRrl(item, 'out')"
            >
              <div class="goods_item_qrcode">
                <img
                  :ref="'qldqrCodeUrl' + index"
                  :width="item.type === 'qrcode' ? 110 : 64"
                  :src="item.downloadCoed"
                  :alt="index"
                />
              </div>
              <div class="goods_item_name">
                <span>
                  {{ item.prodName }}
                </span>
                <span>
                  {{ item.name }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import jybWins from "@/assets/sidebar/jyb_wins.png";
import qgbMac from "@/assets/sidebar/qgb_mac.png";
import qgbWins from "@/assets/sidebar/qgb_wins.png";
import wuliuWx from "@/assets/sidebar/wuliuWx.jpg";
import jingyingbangDown from "@/assets/sidebar/jingyingbang.png";
import qiguanbang from "@/assets/sidebar/qiguanbang.png"; 
import jingyingbangWuliu from "@/assets/sidebar/jingyingbang-wuliu.png"; 
import jingyingbangSc from "@/assets/sidebar/jingyingbang-sc.png"; 
import jingyingbangVip from "@/assets/sidebar/jingyingbang-vip.png"; 
import jingyingbangZc from "@/assets/sidebar/jingyingbang-zc.png"; 
import jingyingbangZl from "@/assets/sidebar/jingyingbang-zl.png"; 
import jingyingbangGd from "@/assets/sidebar/jingyingbang-gd.png";
import wechatSmall from "@/assets/sidebar/xiaochengxu_max_remark.png";
import newQilianduo from "@/assets/sidebar/newQilianduo.png";
import { getQgbAndroid, getqldAndroid } from "@/api/apiDownload";
import {getOS, getDownLoad} from '@/utils/downloadApp.js'
import QRCode from "qrcodejs2";
let isProduction = process.env.VUE_APP_NAME ==="production";
export default {
  data() {
    return {
      jygConf: [ 
        {
          name: "经营帮",
          downloadCoed: jingyingbangDown,
          type: "qrcode"
        },
        {
          name: "微信小程序",
          downloadCoed: wechatSmall,
          type: "qrcode"
        }
      ],
      qgbConf: [
        {
          name: "企管帮",
          downloadCoed: qiguanbang,
          type: "qrcode"
        }
      ],
      qldConf: [
        {
          name: "安卓APP",
          downloadCoed: newQilianduo,
          type: "qrcode"
        }
      ],
      jybConf:[
        {
          name: "经营帮商城",
          type: "qrcode",
          downloadCoed: jingyingbangSc,
        },
        {
          name: "经营帮会员",
          type: "qrcode",
          downloadCoed: jingyingbangVip,
        },
        {
          name: "经营帮招采",
          type: "qrcode",
          downloadCoed: jingyingbangZc,
        },
        {
          name: "经营帮租赁",
          type: "qrcode",
          downloadCoed: jingyingbangZl,
        },
        {
          name: "经营帮工队",
          type: "qrcode",
          downloadCoed: jingyingbangGd,
        },
        {
          name: "经营帮物流",
          type: "qrcode",
          downloadCoed: jingyingbangWuliu,
        },
        {
          name: "微信小程序",
          type: "qrcode",
          downloadCoed: wuliuWx,
        }
      ],
      jybPcConf: [
        {
          name: "Windows 版下载",
          downloadCoed: qgbWins, // jybWins
          type: "link",
          downLink: (function() {
            console.log("getDownLoad(getOS())", getOS(), getDownLoad(getOS()));
            return (
              getDownLoad(getOS()) ||
              "https://sgb-manager-client.oss-cn-beijing.aliyuncs.com/jyb/经营帮客户端.exe"
            );
          })(),
          fineName: "经营帮客户端"
        }
      ],
      qgbPcConf: [
        {
          name: "Windows 版下载",
          downloadCoed: qgbWins,
          type: "link",
          downLink:
            "https://zjkj-sgb-manager-client.obs.cn-east-3.myhuaweicloud.com/builder/%E4%BC%81%E7%AE%A1%E5%B8%AE%E5%AE%A2%E6%88%B7%E7%AB%AF%E5%AE%89%E8%A3%85%E5%8C%85.exe",
          fineName: "企管帮客户端安装包"
        },
        {
          name: "Mac 版下载",
          downloadCoed: qgbMac,
          type: "link",
          downLink:
            "https://zjkj-sgb-manager-client.obs.cn-east-3.myhuaweicloud.com/builder/%E4%BC%81%E7%AE%A1%E5%B8%AE%E5%AE%A2%E6%88%B7%E7%AB%AF%E5%AE%89%E8%A3%85%E5%8C%85_MAC.dmg",
          fineName: "企管帮客户端安装包",
          downLoadType: "mac"
        }
      ],
      qldPcConf: [
        {
          name: "Windows 版下载",
          downloadCoed: qgbWins,
          type: "link",
          downLink: isProduction
            ? "https://gateway.jingyingbang.com/qld-java-server/management/SoftwareInventory/latest/windows_x86_64"
            : "https://api.jybtech.cn/qld-java-server/management/SoftwareInventory/latest/windows_x86_64",

          fineName: "企联多客户端安装包"
        }
      ],
      // 招采正式安装下载地址 https://jingyingbang-client.obs.cn-east-3.myhuaweicloud.com/ZhaoCai/Prod/ZJKJ.JYB-ZC.Setup.exe
      // 招采测试安装下载地址 https://jingyingbang-client.obs.cn-east-3.myhuaweicloud.com/ZhaoCai/Test/ZJKJ.JYB-ZC.Setup.exe

      morePcConf: [
        {
          name: "Windows 版下载",
          prodName: "经营帮招采",
          downloadCoed: qgbWins,
          type: "link",
          downLink: isProduction
            ? "https://jingyingbang-client.obs.cn-east-3.myhuaweicloud.com/ZhaoCai/Prod/ZJKJ.JYB-ZC.Setup.exe"
            : "https://jingyingbang-client.obs.cn-east-3.myhuaweicloud.com/ZhaoCai/Test/ZJKJ.JYB-ZC.Setup.exe",

          fineName: "招采客户端安装包"
        },
        // 会员正式安装包下载地址:https://jingyingbang-client.obs.cn-east-3.myhuaweicloud.com/%20HuiYuan/Prod/ZJKJ.JYB.HY.Setup.exe
        // 会员测试安装包下载地址：https://jingyingbang-client.obs.cn-east-3.myhuaweicloud.com/%20HuiYuan/Test/ZJKJ.JYB.HY.Setup.exe
        {
          name: "Windows 版下载",
          prodName: "经营帮会员",
          downloadCoed: qgbWins,
          type: "link",
          downLink: isProduction
            ? "https://jingyingbang-client.obs.cn-east-3.myhuaweicloud.com/%20HuiYuan/Prod/ZJKJ.JYB.HY.Setup.exe"
            : "https://jingyingbang-client.obs.cn-east-3.myhuaweicloud.com/%20HuiYuan/Test/ZJKJ.JYB.HY.Setup.exe",
          fineName: "会员客户端安装包"
        },
        //物流正式安装包下载地址： https://jyb-wuliu.obs.cn-east-3.myhuaweicloud.com/client-setup/Prod/ZJKJ.JYB.WL.Setup.exe
        // 物流测试安装包下载地址： https://jyb-wuliu.obs.cn-east-3.myhuaweicloud.com/client-setup/Test/ZJKJ.JYB.WL.Setup.exe
        {
          name: "Windows 版下载",
          prodName: "经营帮物流",
          downloadCoed: qgbWins,
          type: "link",
          downLink: isProduction
            ? "https://jyb-wuliu.obs.cn-east-3.myhuaweicloud.com/client-setup/Prod/ZJKJ.JYB.WL.Setup.exe"
            : "https://jyb-wuliu.obs.cn-east-3.myhuaweicloud.com/client-setup/Test/ZJKJ.JYB.WL.Setup.exe",
          fineName: "物流客户端安装包"
        }
      ]
    };
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    loadType: {
      type: String,
      default: "app"
    }
  },
  methods: {
    handleClose() {
      this.$emit("close", false);
    },
    creatQrCode($el, content) {
      var qrcode = new QRCode($el, {
        text: content,
        width: 110,
        height: 110,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H
      });
    },
    downLoadApp(item) {
      if (item.type === "qrcode") {
        return false;
      } else {
        if (item.downLink) {
          var a = document.createElement("a");
          var fileName = item.fileName;
          a.download = fileName;
          a.href = item.downLink;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
      }
    },
    async initQgbConf() {
      let res = await getQgbAndroid();
      let download_url = res.data.data.download_url;
      this.creatQrCode(this.$refs["qgbqrCodeUrl0"][0], download_url);
      this.creatQrCode(
        this.$refs["qgbqrCodeUrl1"][0],
        "https://apps.apple.com/us/app/qi-guan-bang/id1508999712?l=zh&ls=1"
      );
    },
    async initQldConf() {
      let res = await getqldAndroid();
      if (res.data.state === "ok") {
        let appQRlist = res.data.data.apps.list;
        appQRlist.sort(version_code => {
          return function(a, b) {
            return b[version_code] - a[version_code];
          };
        });
        let download_url = appQRlist[0].download_url;
        this.creatQrCode(this.$refs["qldqrCodeUrl0"][0], download_url);
      }
    },
    setItemRrl(item, type) {
      if (item.type == "link") {
        if (type === "in") {
          item.downloadCoed = jybWins;
        } else {
          if (item.downLoadType && item.downLoadType == "mac") {
            item.downloadCoed = qgbMac;
          } else {
            item.downloadCoed = qgbWins;
          }
        }
      }
    }
  },
  created() {},
  mounted() {
    this.$nextTick(() => {
      this.initQgbConf();
      this.initQldConf();
    });
  }
};
</script>

<style lang="scss" scoped>
/deep/ .el-dialog {
  overflow: hidden;
  margin-top: 20px;
  .el-dialog__header {
    padding: 10px;
    padding-left: 20px;
  }
  .el-dialog__body {
    padding: 20px;
    color: #333333;
  }
  .el-dialog__header {
    .el-dialog__title {
      font-size: 16px;
      font-family: MicrosoftYaHei;
      color: #000000;
    }
    .el-dialog__headerbtn {
      font-size: 24px;
      top: 12px;
    }
  }
}
.goods {
  min-height: 202px;
  background: #ffffff;
  box-shadow: 0px 2px 4px 0px rgba(233, 233, 233, 0.31);
  border: 1px solid #e4e7ed;
  margin-bottom: 20px;
  display: flex;
  flex-wrap: wrap;
  width: 618px;
  justify-content: flex-start;
  padding-left: 10px;
  &:last-child {
    margin-bottom: 0;
  }
  .goods-title {
    height: 40px;
    line-height: 40px;
    padding-left: 10px;
    color: #b79255;
    font-size: 14px;
    font-weight: bold;
  }
  .goods-list {
    display: flex;
    flex-wrap: wrap;
    > div {
      // margin-right: 10px;
    }
    .goods-item {
      border: 1px solid #e4e7ed;
      padding: 10px;
      cursor: pointer;
      position: relative;
      height: 130px;
      margin: 0 10px;
      margin-bottom: 20px;
      &.pc-item {
        height: 155px;
        font-size: 14px;
        line-height: 1.5;
        .goods_item_name {
          display: flex;
          flex-direction: column;
          align-items: center;
          bottom: 20px;
        }
      }
      &:hover {
        border-color: #b79255;
        .goods_item_name {
          color: #b79255;
        }
      }
      > .goods_item_qrcode {
        height: 110px;
        width: 110px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .goods_item_name {
        position: absolute;
        bottom: 0;
        text-align: center;
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: #333333;
        width: 100%;
        left: 0;
      }
    }
  }
}
</style>

<style lang="scss">
.dialog-downapp{
  margin-bottom: 0;
  transform: translateY(-50%);
  top: 50%;
}
</style>